import Typography from '@mui/material/Typography';
import { PolicyStreamContactBroker } from './PolicyStreamContactBroker';

export const PolicyStreamLifeInsuranceNotRecommended = () => {
  return (
    <Typography>
      {NO_LIFE_INSURANCE_EXPLANATION} <PolicyStreamContactBroker />.
    </Typography>
  );
};

export const NO_LIFE_INSURANCE_EXPLANATION =
  "You're already in a strong financial position with the savings and insurance coverage you have in place, so there's no need for additional life insurance at this time. If your circumstances change or you’d like to explore other financial options, feel free to reach out directly to your broker directly";
